const services = [
  {
    icon: 'ri-car-line',
    title: 'Auto Body Repair',
    desc: 'From minor scratches to major collision damage, our certified technicians restore every panel to factory-perfect condition with meticulous precision.',
    featured: false,
  },
  {
    icon: 'ri-drop-line',
    title: 'Auto Paint & Perfect Color Matching',
    desc: 'Our signature service. Using advanced spectrophotometry and OEM-grade materials, we achieve flawless color accuracy that exceeds factory standards — every single time.',
    featured: true,
    badge: 'SIGNATURE',
  },
  {
    icon: 'ri-tools-line',
    title: 'Frame & Structural Repair',
    desc: 'Precision computerized frame straightening restores your vehicle\'s structural integrity to exact manufacturer specifications, ensuring safety and performance.',
    featured: false,
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Dent & Bumper Repair',
    desc: 'Seamless paintless dent removal and expert bumper restoration that leaves no trace of damage — only perfection.',
    featured: false,
  },
  {
    icon: 'ri-window-line',
    title: 'Auto Glass',
    desc: 'OEM-quality windshield and glass replacement with precision calibration for advanced driver assistance systems (ADAS).',
    featured: false,
  },
  {
    icon: 'ri-sparkling-line',
    title: 'Auto Detailing',
    desc: 'Concours-level detailing that elevates your vehicle\'s appearance to showroom brilliance — inside and out.',
    featured: false,
  },
  {
    icon: 'ri-timer-flash-line',
    title: 'Rapid Repair Services',
    desc: 'Expedited repair programs for qualifying damage, minimizing your time without your vehicle while maintaining our uncompromising quality standards.',
    featured: false,
  },
  {
    icon: 'ri-file-paper-2-line',
    title: 'Insurance Claim Assistance',
    desc: 'We navigate the insurance process on your behalf — from initial claim to final approval — ensuring you receive the full repair your vehicle deserves.',
    featured: false,
  },
];

export default function Services() {
  return (
    <section id="services" className="bg-[#080808] py-28 md:py-36 w-full">
      <div className="max-w-[1600px] mx-auto px-6 md:px-16">
        {/* Section header */}
        <div className="text-center mb-20">
          <span className="text-yellow-600 text-xs tracking-[0.4em] uppercase font-light">What We Offer</span>
          <h2 className="font-serif text-4xl md:text-5xl text-white mt-4 mb-5">
            Premium <span className="text-yellow-400 italic">Services</span>
          </h2>
          <div className="flex items-center justify-center gap-4">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-yellow-600"></div>
            <div className="w-2 h-2 rounded-full bg-yellow-600"></div>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-yellow-600"></div>
          </div>
          <p className="text-white/50 text-sm tracking-wide mt-6 max-w-xl mx-auto leading-relaxed">
            Every service is performed with factory-level precision, premium materials, and an obsessive commitment to perfection.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className={`relative group rounded-xl p-8 transition-all duration-500 cursor-default
                ${service.featured
                  ? 'bg-gradient-to-b from-purple-950/60 to-black border-2 border-yellow-500/60 lg:col-span-2'
                  : 'bg-[#111111] border border-yellow-700/20 hover:border-yellow-600/50'
                }`}
            >
              {service.badge && (
                <div className="absolute top-5 right-5 px-3 py-1 bg-yellow-500 text-black text-[10px] tracking-widest uppercase font-bold rounded-full">
                  {service.badge}
                </div>
              )}

              {/* Icon */}
              <div className={`w-14 h-14 flex items-center justify-center rounded-full mb-6 transition-all duration-300
                ${service.featured
                  ? 'bg-yellow-500/20 group-hover:bg-yellow-500/30'
                  : 'bg-yellow-900/20 group-hover:bg-yellow-900/40'
                }`}>
                <i className={`${service.icon} text-2xl text-yellow-500`}></i>
              </div>

              <h3 className={`font-serif mb-4 text-white leading-tight
                ${service.featured ? 'text-2xl' : 'text-lg'}`}>
                {service.title}
              </h3>
              <p className={`text-white/50 leading-relaxed font-light
                ${service.featured ? 'text-base' : 'text-sm'}`}>
                {service.desc}
              </p>

              {/* Bottom accent */}
              <div className={`mt-6 h-px bg-gradient-to-r from-yellow-600/40 to-transparent transition-all duration-300
                ${service.featured ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
